export { default } from "./ToggleSwitch-component";
